import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

// !COMPONENTS
import Layout from '@shared/components/layout'
import queryGraphql from '@shared/components/queryGraphql'
import { GET_SERIES_NEWS_VIDEOS } from '@graphql/series/home.query'
import { handleApiError, parallelCalls } from '@shared-submodule/utils'
import styles from './style.module.scss'
// import GoogleAds from '@shared-submodule/sm-components/googleAds'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
import useWindowSize from '@shared/hooks/windowSize'
import IPLHeader from '@shared/components/ipl/IPLHeader'
import VenueMweb from '@shared/components/WPLComponents/venueMweb'
import { GET_BOUNDARIES_DATA, GET_IPL_DATA } from '@graphql/ipl/ipl'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { GET_PURPLE_ORANGE_CAP } from '@graphql/series/topPlayers.query'
import IPLMatches from '@shared/components/ipl/IPLMatches'
import ChampionTable from '@shared/components/Champions-trophy/championTable'
import BoundaryTracker from '@shared/components/ipl/IPLBoundaryTracker'
import IPLCapHolder from '@shared/components/ipl/IPLCapHolder'
import IPLTeams from '@shared/components/ipl/IPLTeams'
import IPLPreviousWinners from '@shared/components/ipl/IPLPreviousWinner'
import ChampionsInfo from '@shared/components/Champions-trophy/championsInfo'
import DailyNews from '@shared/components/ipl/DailyNews'
import IPLEditorPick from '@shared/components/ipl/IPLEditorPick'
import BreadcrumbNav from '@shared/components/breadcrumbNav'
// import { skyAddData } from '@shared/constants/skyAds'
import dynamic from 'next/dynamic'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function IPL({ allData, news, seoData, editorPick, purpleOrangeCap, fourSixData }) {
  const [width] = useWindowSize()
  const data = news?.listSeriesArticlesVideosFront?.oArticles
  const editorPickData = editorPick?.listSeriesArticlesVideosFront?.oArticles
  const fourSixHits = fourSixData?.data?.getBoundaries
  const venues = allData?.data?.getMajorSeriesData?.aVenues
  const teams = allData?.data?.getMajorSeriesData?.aTeams
  const pointsData = allData?.data?.getMajorSeriesData?.aSeriesStandings
  const fixture = allData?.data?.getMajorSeriesData?.aFixtures
  const { addTop, mobSm, addBottom, addLeft } = reviveAdData

  return (
    <Layout
      data={{
        oSeo: seoData?.getSeoData
      }}>
      <>
        <IPLHeader />
        <main className="common-section">
          <Container>
            <Row>
              <BreadcrumbNav />
              <h1 id="matchContainer" className={`my-md-0  mb-3 w-100 text-left ${styles.heading}`}>
                {'Indian Premier League 2025'}
              </h1>
              <div className="w-full d-none d-xl-flex justify-content-center ">
                {/* <GoogleAds
                  addId={googleAddData?.addTop?.addId}
                  divId={googleAddData?.addTop?.divId}
                  dimension={googleAddData?.addTop?.dimension}
                  slotId={googleAddData?.addTop?.slotId}
                  className={'my-2'}
                /> */}
                <ReviveAds {...addTop} className={'my-2'}/>
              </div>
              <div className="w-full d-flex d-xl-none justify-content-center">
                {/* <GoogleAds
                  addId={googleAddData?.mobSm?.addId}
                  divId={googleAddData?.mobSm?.divId}
                  slotId={googleAddData?.mobSm?.slotId}
                  dimension={googleAddData?.mobSm?.dimension}
                  className={'my-1'}
                /> */}
                <ReviveAds {...mobSm} className={'my-1'}/>
              </div>
              <Col lg={9} className="left-content">
                <IPLMatches fixture={fixture} />
                {width < 767 && (<div className='mt-4 d-flex flex-column'>
                  <ChampionTable pointsData={pointsData} />
                  <IPLCapHolder purpleOrangeCap={purpleOrangeCap} />
                </div>
                )}
                <BoundaryTracker fourSixHits={fourSixHits} />
                <IPLTeams team={teams} />
                {width < 767 && (<>
                  <div className="w-full d-flex d-xl-none justify-content-center my-2">
                    {/* <GoogleAds
                      addId={googleAddData?.mobLg?.addId}
                      divId={googleAddData?.mobLg?.divId}
                      dimension={googleAddData?.mobLg?.dimension}
                      slotId={googleAddData?.mobLg?.slotId}
                      className={'my-3'}
                    /> */}
                    <ReviveAds {...addLeft} className={'my-3'}/>
                  </div>
                  <IPLEditorPick editorPickData={editorPickData} />
                  <IPLPreviousWinners />
                  <div className="mb-md-4  mb-0">
                    <h4 className="font-bold">Venues</h4>
                    <VenueMweb venues={venues} />
                  </div>
                </>
                )}
              </Col>

              <Col lg={3} className={`common-sidebar ${styles.margin}`}>
                <div className='d-none d-xl-flex'>
                  <ChampionTable pointsData={pointsData} />
                </div>
                {width > 767 && (
                  // {/* <GoogleAds
                  //   addId={googleAddData?.addLeft?.addId}
                  //   divId={googleAddData?.addLeft?.divId}
                  //   dimension={googleAddData?.addLeft?.dimension}
                  //   slotId={googleAddData?.addLeft?.slotId}
                  //   className={'my-4'}
                  // /> */}
                  <div className='d-flex justify-content-center mt-2'>
                  <ReviveAds {...addLeft} className={'my-4'}/>
                  </div>
                )}
                {width > 767 && <IPLCapHolder purpleOrangeCap={purpleOrangeCap} />}
              </Col>
              <Col xs={12}>
                {width > 767 && (<>
                <IPLEditorPick editorPickData={editorPickData} />
                  <div className="w-full d-none d-xl-flex justify-content-center ">
                    {/* <GoogleAds
                      addId={skyAddData?.addBottom?.addId}
                      divId={skyAddData?.addBottom?.divId}
                      dimension={skyAddData?.addBottom?.dimension}
                      slotId={skyAddData?.addBottom?.slotId}
                      className={'my-3'}
                    /> */}
                    <ReviveAds {...addBottom} className={'my-3 text-center'}/>
                  </div>
                </>
                )}
              </Col>
              {width > 767 && <Col lg={9}>
                <IPLPreviousWinners />
              </Col>}
              <Col lg={3} >
                {width > 767 && <ChampionsInfo venues={venues} />}
                <div className={styles.partner}></div>
              </Col>
              <Col xs={12}>
                <DailyNews data={data} />
              </Col>
              <a href="https://o2o.to/i/0MacsN" target="_blank" rel="noopener noreferrer nofollow">
                <div className={`d-md-flex d-none justify-content-center align-items-center ${styles.downloadBanner}`}></div>
              </a>
            </Row>
          </Container>
        </main>

      </>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')
    const seriesId = '67946fd3a867d4fa473c2b43'
    const allData = await queryGraphql(GET_IPL_DATA, {
      input: {
        iSeriesId: '67946fd3a867d4fa473c2b43'
      }
    })

    const [editorPick, news] = await parallelCalls([
      queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: {
          nLimit: 3,
          nSkip: 0,
          iSeriesId: seriesId,
          eType: 'n'
        }
      }),
      queryGraphql(GET_SERIES_NEWS_VIDEOS, {
        input: {
          nLimit: 6,
          nSkip: 0,
          iSeriesId: seriesId,
          eType: 'n'
        }
      })
    ])
    const purpleOrangeCap = await queryGraphql(GET_PURPLE_ORANGE_CAP, { input: { iSeriesId: '67946fd3a867d4fa473c2b43' } })
    const fourSixData = await queryGraphql(GET_BOUNDARIES_DATA, { input: { iSeriesId: '67946fd3a867d4fa473c2b43', nLimit: 5 } })
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'ipl-indian-premier-league-2025' } })

    return {
      props: {
        news: news || {},
        editorPick: editorPick || {},
        allData: allData || {},
        purpleOrangeCap: purpleOrangeCap || {},
        fourSixData: fourSixData || {},
        seoData
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e?.status)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

IPL.propTypes = {
  news: PropTypes.object,
  editorPick: PropTypes.object,
  seoData: PropTypes.object,
  allData: PropTypes.object,
  fourSixData: PropTypes.object,
  info: PropTypes.array,
  venues: PropTypes.array,
  teams: PropTypes.array,
  purpleOrangeCap: PropTypes.object
}

export default IPL
